export default __webpack_public_path__ + "static/media/SDG-icon-NL-13.ed6db60f.svg";